module.exports = __webpack_public_path__ + "static/media/student-game-comment-prev.c65dfa99.png";